import React, { useState, useEffect, Suspense } from 'react'
import { Route, Redirect, BrowserRouter, withRouter, useLocation } from 'react-router-dom'

//Components
import Login from '../pages/Login'
import Roles from '../pages/Roles'
import Home from '../pages/Home'
import PrimerPago from '../pages/PrimerPago'
import Lpdp from '../pages/Lpdp'
import Beneficiarios from '../pages/Beneficiarios'
import DeclaracionSalud from '../pages/DeclaracionSalud'
import Requisitos from '../pages/Requisitos'
import PagoRecurrente from '../pages/PagoRecurrente'
import Firma from '../pages/Firma'
import Asegurado from '../pages/Asegurado'
import Contratante from '../pages/Contratante'
import Producto from '../pages/Producto'
import ResumenADN from '../pages/ResumenADN'
import ProspectoFinal from '../pages/ProspectoFinal'
import CargandoPagina from '../components/CargandoPagina'
import SafetyPay from '../pages/SafetyPay'

//Token
import * as AuthToken from './auth/Auth-token'
import * as Funciones from "./funciones";
import * as Constantes from "./constantes";
import {ErrorBoundary} from 'react-error-boundary'
import ErrorFallback from './error/errorFallback'
import MensajeError from '../components/MensajeError/MensajeError'
import CargandoInicio from '../components/CargandoInicio'
import PerdidaSesion from '../components/PerdidaSesion'

const PrivateRoute = ({component: Component, auth, path }) => {
    return (
        <Route path={path} exact render={props => auth === true
            ? <Suspense fallback={<CargandoPagina />}>
                <Component auth={auth} {
                ...props
                } />
            </Suspense>
            : <Redirect to={{pathname: '/'}} />
            }
        />
    )
}

const PublicRoute = ({component: Component, auth, path, exact }) => {
    return (
        <Route path={path} exact={exact !== undefined ? exact : false} render={props => auth === false
            ? <Component auth={auth} {
                ...props
                } />
            : <Redirect to={{pathname: '/home'}} />
            }
        />
    )
}

function _ScrollToTop(props) {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    return props.children
}

const ScrollToTop = withRouter(_ScrollToTop)

const Routes = ({ history }) => {
    let users = localStorage.getItem('usersSD') !== undefined ? JSON.parse(localStorage.getItem('usersSD') || null) : null
    let user = users !== null ? users.filter(user => user.isAuthenticated)[0] : null

    let mostrarRoles = user !== undefined && user !== null && user.info !== undefined && user.info !== null &&
        user.roles !== undefined && user.roles !== null && user.roles.length > 0

    const [ rutas, setRutas ] = useState(null)
    let isAuthenticated = false

    const idToken = AuthToken.getToken('msal.idtoken')
    if(idToken !== undefined && idToken !== null) {
        isAuthenticated = true
    }

    useEffect(() => {
        if(!isAuthenticated) {
            setRutas(
                <BrowserRouter>
                    <ScrollToTop>
                        <PublicRoute path='/notificaciones/safetyPay'
                            auth={isAuthenticated}
                            component={SafetyPay}
                            exact={true} />
                        <PublicRoute path='/'
                            auth={isAuthenticated}
                            component={Login}
                            exact={true} />
                        <PublicRoute path='/home'
                            auth={isAuthenticated}
                            component={Login}
                            exact={true} />
                        <PublicRoute path='/login'
                            auth={isAuthenticated}
                            component={Login}
                            exact={true} />
                    </ScrollToTop>
                </BrowserRouter>
            )
        } else {
            if(user === undefined || user === null || user.info === undefined || user.info === null ||
                user.roles === undefined || user.roles === null || user.roles.length === 0) {
                    setRutas(
                        <BrowserRouter>
                            <ScrollToTop>
                                <Route path='/' exact render={props =>
                                    <Redirect to={{pathname: '/roles'}} />
                                } />
                                <Route path='/*' exact render={props =>
                                    <Redirect to={{pathname: '/roles'}} />
                                } />
                                <PrivateRoute path='/roles'
                                    auth={isAuthenticated}
                                    component={Roles} />
                            </ScrollToTop>
                        </BrowserRouter>
                    )
            } else {
                setRutas(
                    <BrowserRouter>
                        <ScrollToTop>
                            <Route path='/' exact render={props =>
                                <Redirect to={{pathname: '/home'}} />
                            } />
                            <Route path='/login' exact render={props =>
                                <Redirect to={{pathname: '/home'}} />
                            } />
                            <PrivateRoute path='/home'
                                auth={isAuthenticated }
                                component={Home} />
                            <PrivateRoute path='/resumenADN'
                                auth={isAuthenticated }
                                component={ResumenADN} />
                            <PrivateRoute path='/informacion/lpdp'
                                auth={isAuthenticated }
                                component={Lpdp} />
                            <PrivateRoute path='/informacion/beneficiarios'
                                auth={isAuthenticated }
                                component={Beneficiarios} />
                            <PrivateRoute path='/informacion/declaracionSalud'
                                auth={isAuthenticated }
                                component={DeclaracionSalud} />
                            <PrivateRoute path='/informacion/asegurado'
                                auth={isAuthenticated }
                                component={Asegurado} />
                            <PrivateRoute path='/informacion/contratante'
                                auth={isAuthenticated }
                                component={Contratante} />
                            <PrivateRoute path='/informacion/productos'
                                auth={isAuthenticated }
                                component={Producto} />
                            <PrivateRoute path='/informacion/pagoRecurrente'
                                auth={isAuthenticated }
                                component={PagoRecurrente} />
                            <PrivateRoute path='/requisitos'
                                auth={isAuthenticated }
                                component={Requisitos} />
                            <PrivateRoute path='/firma'
                                auth={isAuthenticated }
                                component={Firma} />
                            <PrivateRoute path='/primerPago'
                                auth={isAuthenticated }
                                component={PrimerPago} />
                            <PrivateRoute path='/prospectoFinal'
                                auth={isAuthenticated }
                                component={ProspectoFinal} />
                        </ScrollToTop>
                    </BrowserRouter>
                )
            }
        }
    }, [mostrarRoles])
    // eslint-disable-next-line

    const reloadError = () => {
        // reset the state of your app so the error doesn't happen again
        window.location.reload()
    }

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={reloadError}>
                <React.Fragment>
                    {process.env.REACT_APP_AMBIENTE === 'DESA' || process.env.REACT_APP_AMBIENTE === 'CERTI'
                        ? <label style={{position: 'fixed', bottom: '0px', right: '0', opacity: '0.2'}}>
                            {"versión v" + Funciones.transformarStringFechaToFormato(new Date, Constantes.FORMATO_FECHA_5)}
                        </label>
                        : null
                    }
                    {rutas}
                    <MensajeError />
                    <CargandoInicio />
                    <PerdidaSesion />
                </React.Fragment>
        </ErrorBoundary>
    )
}

export default Routes;